import { InjectionToken } from '@angular/core';

const pickHex = (color1: RGBColor, color2: RGBColor, weight: number): string => {
    const p = weight;
    const w = p * 2 - 1;
    const w1 = (w / 1 + 1) / 2;
    const w2 = 1 - w1;

    return `#${[
        Math.round(color1.r * w1 + color2.r * w2),
        Math.round(color1.g * w1 + color2.g * w2),
        Math.round(color1.b * w1 + color2.b * w2)
    ]
    .map(val => val.toString(16).padStart(2, '0'))
    .join('')}`;
};

export default pickHex;

export interface RGBColor {
    r: number;
    g: number;
    b: number;
}
export type PickHexProvider = (color1: RGBColor, color2: RGBColor, weight: number) => string;
export const PICK_HEX =
    new InjectionToken('CREATE_STYLE', {
        factory: () => pickHex
    });
